// extracted by mini-css-extract-plugin
export default {"seg":"ProfileViewToggle_seg__A+paw","on":"ProfileViewToggle_on__UJR0w"};